const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Failed to read audio chunk as base64"));
        return;
      }

      const base64 = result.split(",")[1];
      if (!base64) {
        reject(new Error("Failed to encode audio chunk as base64"));
        return;
      }

      resolve(base64);
    };

    reader.onerror = () =>
      reject(reader.error ?? new Error("Failed to read audio chunk"));
    reader.readAsDataURL(blob);
  });

export { blobToBase64 };
